import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.5 2.5H5.5M5.5 7.5V6M4 7.5H4.005M2.5 7.5H2.505M2.5 6H2.505M4 6H4.005M5.5 4.5H5.505M4 4.5H4.005M2.5 4.5H2.505M1.5 9.5H6.5C7.05228 9.5 7.5 9.05228 7.5 8.5V1.5C7.5 0.947715 7.05228 0.5 6.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V8.5C0.5 9.05228 0.947715 9.5 1.5 9.5Z" />
  </svg>
);
